import { CSSObject } from "@emotion/react";
import { mediaQueryStyles, constants } from "@newsela/angelou";

const { mediaQuery: breakpoint } = mediaQueryStyles;

const { Breakpoints } = constants.breakpoints;

const {
  colors: { ui },
} = constants;
const core700 = ui.core[700];
const white700 = ui.white[700];

export const bannerCss: CSSObject = {
  position: "sticky",
  bottom: "0",
  left: "0",
  display: "block",
  width: "100%",
  height: "170px",
  padding: "16px 16px",
  marginBottom: "0 !important",
  backgroundColor: core700,
  zIndex: "3",

  [breakpoint.downTo(Breakpoints.xs)]: {
    height: "150px",
    padding: "16px 36px",
  },

  [breakpoint.downTo(Breakpoints.sm)]: {
    height: "80px",
    padding: "16px 16px 16px 16px",
  },

  [breakpoint.downTo(Breakpoints.md)]: {
    padding: "16px 36px",
  },

  // Overriding the default padding from the Angelou's Banner component
  div: {
    div: {
      paddingRight: "0px",

      div: {
        paddingTop: "0px",
      },
    },
  },
};

export const bannerTextCss: CSSObject = {
  fontSize: "16px !important",
  fontStyle: "normal",
  fontWeight: "400",
  lineHeight: "178%",
};

export const innerBannerContentCss: CSSObject = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "20px",
  width: "100%",

  [breakpoint.downTo(Breakpoints.sm)]: {
    gap: "none",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },

  section: {
    alignSelf: "flex-start",

    [breakpoint.downTo(Breakpoints.sm)]: {
      alignSelf: "center",
    },
  },

  div: {
    alignSelf: "flex-end",

    [breakpoint.downTo(Breakpoints.sm)]: {
      alignSelf: "center",
    },
  },
};

const commonLinkCss: CSSObject = {
  fontFamily: "Circular",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "100%",
  color: white700,
};

export const pageLinkCss: CSSObject = {
  marginRight: "16px",
  ...commonLinkCss,
};

export const goToAdminLinkCss: CSSObject = {
  ...commonLinkCss,
};

export const publishButtonCss: CSSObject = {
  backgroundColor: white700,
  color: core700,

  "&:hover": {
    backgroundColor: white700,
    color: core700,
  },
};
